import React from "react";
import styled from "styled-components";

import img from "../../../assets/site_files/social_media/bloved/Bloved.jpg";
import img1 from "../../../assets/site_files/social_media/bloved/Bloved_Showcase.jpg";
import img2 from "../../../assets/site_files/social_media/bloved/BLoved_iMac2.jpg";

const Bloved = () => {
  return (
    <Hero className="item" style={{ backgroundImage: `url(${img})` }}>
      <Container>
        <Text>
          <h1>
            <div className="title">Bloved</div>
          </h1>
          <h3 className="slogan">CUSTOM MADE JEWELLERY</h3>
          &nbsp; &nbsp;
          <TextWrapper>
            <h2>
              <div className="subtitle">Client</div>
            </h2>
            &nbsp;
            <p></p>
            &nbsp;
            <h2>
              <div className="subtitle">Services</div>
            </h2>
            &nbsp;
            <p>• Branding • Photography • Social Media • Website</p>
            &nbsp;
            <h2>
              <div className="subtitle">Challange</div>
            </h2>
            &nbsp;
            <p>Text 3</p>
            &nbsp;
            <h2>
              <div className="subtitle">Solution</div>
            </h2>
            &nbsp;
            <p>
              After an intense research to fit the art-deco character of
              Christjin Jason in to the Brand Identity, i design an elegant
              expression for this brand. And set up the whole Brand and Visual
              Identity and al needed media, social media and online or printed
              expressions.
            </p>
          </TextWrapper>
        </Text>
        <Picture1 />
        <Picture2 />
      </Container>
    </Hero>
  );
};

const Hero = styled.div`
  margin-top: -4rem;
  width: 100%auto;
  height: 40rem;
  border-radius: 0 0 10px 10px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  box-shadow: 0 5px 20px rgba(255, 255, 255, 0.3);
  @media (max-width: 64rem) {
    height: 28rem;
  }
  @media (max-width: 40rem) {
    height: 25rem;
  }
`;

const Container = styled.div`
  flex: 1;
  max-width: 100%;
  margin-left: 18%;
  margin-right: 18%;
  padding-top: 10rem;
  height: 150vh;
  align-items: center;
  justify-content: center;
  @media (max-width: 40rem) {
    margin-left: 0;
    margin-right: 0;
  }
  .title {
    opacity: 0.8;
    color: #fff;
    text-align: center;
    text-shadow: 2px 2px 5px #000000;
    @media (max-width: 64rem) {
      margin-top: -5rem;
      @media (max-width: 40rem) {
        padding-top: 0.1rem;
      }
    }
  }
  .slogan {
    opacity: 0.8;
    color: #fff;
    text-align: center;
    text-shadow: 2px 2px 5px #000000;
    @media (max-width: 64rem) {
      margin-top: -3rem;
      @media (max-width: 40rem) {
        margin-top: -1rem;
      }
    }
  }
  .subtitle {
    opacity: 0.8;
    color: #fff;
    text-align: left;
  }
  h1 {
    text-align: left;
    font-size: 8rem;
    padding-top: 8rem;
    padding-bottom: 4rem;
    @media (max-width: 64rem) {
      margin-top: -4rem;
      line-height: 6rem;
      @media (max-width: 40rem) {
        font-size: 4rem;
        padding: 1.5rem;
        line-height: 4rem;
        padding-top: 6rem;
      }
    }
    h2 {
      text-align: center;
    }
    h3 {
      text-align: center;
      color: #ed6a5a;
    }
    p {
      padding-right: 3rem;
      line-height: 1.6rem;
      font-size: 1.2rem;
      font-weight: 200;
    }

    b {
      color: #ed6a5a;
    }
  }
`;

const Text = styled.div`
  color: #fff;
  line-height: 1.6rem;
  padding: 2rem;
  font-size: 1.2rem;
  font-weight: 200;
  @media (max-width: 64rem) {
    top: -6rem;

    @media (max-width: 40rem) {
      font-size: 1rem;
      padding: 1.5rem;
      font-weight: 200;
    }

    p {
      opacity: 0.8;
      padding-bottom: 1rem;
      @media (max-width: 40rem) {
        padding-bottom: 0.8rem;
      }
    }

    a {
      color: inherit;
      text-decoration: none;
      font-weight: 700;
      color: tomato;
    }
  }
`;

const TextWrapper = styled.div`
  @media (max-width: 120rem) {
    padding-top: 15rem;
    @media (max-width: 64rem) {
      margin-top: -9rem;
      margin-left: 0;
      margin-right: 0;
    }
    @media (max-width: 48rem) {
      margin-top: 5rem;
    }
    @media (max-width: 40rem) {
      padding-top: 2rem;
      margin-left: 3rem;
      margin-right: 1rem;
    }
  }
`;

const Picture1 = styled.div`
  background-image: url(${img1});
  margin-top: 1.5rem;
  max-width: 100%;
  height: 50rem;
  justify-content: center;
  display: block;
  justify-content: center;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(255, 255, 255, 0.3);
  @media (max-width: 64rem) {
    height: 25rem;
  }
  @media (max-width: 48rem) {
    height: 20rem;
  }
  @media (max-width: 40rem) {
    margin-left: 2.1rem;
    margin-right: 2.1rem;
    height: 12rem;
  }
`;

const Picture2 = styled.div`
  background-image: url(${img2});
  margin-top: 1.5rem;
  max-width: 100%;
  height: 50rem;
  justify-content: center;
  display: block;
  justify-content: center;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(255, 255, 255, 0.3);
  @media (max-width: 64rem) {
    height: 25rem;
  }
  @media (max-width: 48rem) {
    height: 20rem;
  }
  @media (max-width: 40rem) {
    margin-left: 2.1rem;
    margin-right: 2.1rem;
    height: 12rem;
  }
`;

export default Bloved;
